import React, { useEffect, useState, useRef } from 'react';

import './PopUpRate.css';
import close from '../../../image/CloseBlack.svg';

export default function PopUpRate(props) {
    const {
        setPopUpState,
        criterionRequestParam,
        criterionPopUpData
    } = props;
    console.log(criterionPopUpData);
    function handleClose(e) {
        if (e.target.id === "popup-criterion") {
            setPopUpState(false);
            document.body.style.overflow = 'auto';
        }
    }

    const handleClick = () => {
        setPopUpState(false);
        document.body.style.overflow = 'auto';
    }

    return (
        <div className='criterion-popup-container' id='popup-criterion' onClick={handleClose}>
            <div className='criterion-popup'>
                <div className='criterion-header'>
                    <div className='criterion-direction'>
                        <p className='criterion-title-name'>{criterionPopUpData.criterionName}</p>
                        <div className='criterion-date-age'>
                            <p className='criterion-date-age-text'>
                                {criterionRequestParam.dateBirthName}
                            </p>
                        </div>
                    </div>
                    <img className='criterion-close'
                        src={close}
                        alt='close'
                        onClick={handleClick} />
                </div>
                <table className='criterion-table'>
                    <thead>
                        <tr className='table-row'>
                            <th className='table-row-criterion'>Критерии</th>
                            <th className='table-row-poin'>Баллы</th>
                        </tr>
                    </thead>
                    <tbody>
                        <DisplayCriterionItems data={criterionPopUpData.attributes} />
                        {/* <tr className='table-row'>
                            <td>Не интересуется числами и количествами</td>
                            <td className='criterion-point'>0</td>
                        </tr>
                        <tr className='table-row'>
                            <td>Знает цифру 1, показывает один предме</td>
                            <td className='criterion-point'>1</td>
                        </tr>
                        <tr className='table-row'>
                            <td>Знает цифры 1-2, считает до 2 предметов</td>
                            <td className='criterion-point'>2</td>
                        </tr> */}
                    </tbody>
                </table>
            </div>
        </div>

    )
}

function DisplayCriterionItems(props) {
    const { data } = props;

    return Object.entries(data).map(([key, value]) => (
        <tr className='table-row' key={key}>
            <td className='criterion-description'>{value}</td>
            <td className='criterion-point'>{key}</td>
        </tr>
    ));
}